import * as React from "react";
const baseClassName = "side-arrow";
export class SideArrow extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnClick = () => this.props.onClick(this.props.direction);
    }
    render() {
        const { direction } = this.props;
        const Arrow = arrowMap[direction];
        return (React.createElement("button", { type: "button", className: `${baseClassName} ${baseClassName}--${direction}`, "data-testid": "button-side-arrow", onClick: this.handleOnClick },
            React.createElement(Arrow, null)));
    }
}
const arrowMap = {
    left() {
        return (React.createElement("svg", { className: `${baseClassName}-icon`, xmlns: "http://www.w3.org/2000/svg", "data-testid": "side-arrow-left", width: "9", height: "16", viewBox: "0 0 9 16", fill: "none" },
            React.createElement("path", { d: "M7.5 14.25L1.25 8L7.5 1.75", stroke: "#ABABAB", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
    },
    right() {
        return (React.createElement("svg", { className: `${baseClassName}-icon`, xmlns: "http://www.w3.org/2000/svg", "data-testid": "side-arrow-right", width: "9", height: "16", viewBox: "0 0 9 16", fill: "none" },
            React.createElement("path", { d: "M1.5 1.75L7.75 8L1.5 14.25", stroke: "#ABABAB", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
    },
};
//# sourceMappingURL=SideArrow.js.map